export enum SourceMessage {
    Validation,
    ValidationDecode,
    Api,
    ViewModel
}